import { useEffect } from "react";
import { useRecoilState } from "recoil";
import _ from "lodash";
import { useQuery } from "@apollo/client";
import { OC_GET_CUSTOMER_LICENCES } from "oc/graphql";
import { useOcPolling } from "oc/hooks";
import { ocCustomerLicencesState } from "states";

export const useOcCustomerLicences = () => {
  const [, setCustomerLicences] = useRecoilState(
    ocCustomerLicencesState,
  );
  const { data, loading, error } = useQuery(OC_GET_CUSTOMER_LICENCES, {
    fetchPolicy: "cache-and-network",
    pollInterval: useOcPolling(1000 * 60),
  });

  //Cannot update a component (`App`) error requires useEffect
  useEffect(() => {
    if (data?.getCustomerLicences) {
      const result = data?.getCustomerLicences || {};
      const ocLicences = result?.ocLicences || null;
      if (result && ocLicences) {
        const newState = { ...ocLicences };
        delete newState.__typename;
        // Use functional setState to avoid customerLicences in dependency array
        setCustomerLicences((prev: typeof newState) => {
          if (!_.isEqual(prev, newState)) {
            return newState;
          }
          return prev;
        });
      }
    }
  }, [data, setCustomerLicences]);

  return {
    data: data?.getCustomerLicences || {},
    licences: data?.getCustomerLicences?.ocLicences || {},
    loading,
    error,
  };
};

export default useOcCustomerLicences;
